import { userPrivileges } from '@apollo-internal/cache';
import PrivilegeNames from '../../../../../constants/privilegeNames';
import { ATL_SELECTION_TYPE } from '../constants';
import { useReactiveVar } from '@apollo/client';
import { useEffect, useState } from 'react';
import { APPRAISER_EVENT_STAGE } from '../../../constants/AppraiserEventStage';
import { useIsUserActingAsATMStore } from '../../../CalendarStore';
import { useShallow } from 'zustand/shallow';

export const useAtlSelectionType = (eventDataLoading, eventStage, settings) => {
  const privileges = useReactiveVar(userPrivileges);
  const isUserActingAsATM = useIsUserActingAsATMStore(useShallow(state => state.isUserActingAsATM));

  const [selectionType, setSelectionType] = useState(
    getSelectionType(settings, privileges, isUserActingAsATM, eventDataLoading, eventStage)
  );

  useEffect(() => {
    const selectionType = getSelectionType(
      settings,
      privileges,
      isUserActingAsATM,
      eventDataLoading,
      eventStage
    );
    setSelectionType(selectionType);
  }, [privileges, eventDataLoading, eventStage, settings, isUserActingAsATM]);

  return selectionType;
};

const getSelectionType = (
  settings,
  privileges,
  isUserActingAsATM,
  eventDataLoading,
  eventStage
) => {
  const { canEditAtlObserver, canViewAtl, canViewAtlObserver } = settings || {};
  const canUserEditAtl = privileges.includes(PrivilegeNames.Calendar_EditEvent_EditExtraFields);

  if (canViewAtl && canViewAtlObserver) {
    return ATL_SELECTION_TYPE.VIEW_ATL_WITH_OBSERVER;
  }

  if (canViewAtl || isUserActingAsATM) {
    return ATL_SELECTION_TYPE.VIEW_ATL;
  }

  if (canEditAtlObserver) {
    return ATL_SELECTION_TYPE.ATL_WITH_OBSERVER;
  }

  if (canUserEditAtl) {
    return ATL_SELECTION_TYPE.ATL;
  }

  if (eventDataLoading) {
    return ATL_SELECTION_TYPE.TBD;
  }

  if (eventStage === APPRAISER_EVENT_STAGE.DRAFT) {
    return ATL_SELECTION_TYPE.ATL_PREFERENCES;
  }

  return ATL_SELECTION_TYPE.VIEW_ATL;
};
